import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BRAND_GREEN } from '@/components/brand/BrandHeader';

// Shared top header on every screen that isn't a home (homes have the
// taller BrandHeader): the African Farm logo and name on the brand
// green, so the app feels like one product.
//
// Tapping the logo navigates to /, which is either the splash
// (unauthenticated — where the language picker lives) or the dashboard
// (authenticated). Either way it's a safe "back to start" gesture.
//
// Props:
//   trailing   Optional element on the right (e.g. LanguagePickerButton
//              on login/register).
export default function AppHeader({ trailing }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const name = `${t('brand.name.first')} ${t('brand.name.second')}`;

  return (
    <header
      className="w-full flex items-center justify-between gap-3 py-2 px-4 text-white"
      style={{ backgroundColor: BRAND_GREEN }}
      data-testid="app-header"
    >
      <button
        type="button"
        onClick={() => navigate('/')}
        className="flex items-center gap-2 min-w-0 hover:opacity-90 transition-opacity"
        aria-label={name}
        data-testid="app-header-logo-btn"
      >
        <img src="/assets/brand/logo-mark.png" alt="" className="w-11 h-11 shrink-0" decoding="async"
             data-testid="app-header-logo" />
        <span className="font-heading text-xl font-bold whitespace-nowrap truncate">{name}</span>
      </button>
      {trailing && <div className="shrink-0">{trailing}</div>}
    </header>
  );
}
